import Element from '../../../Prototype/UI/Element';
import Game from '../../../Game';
import AnimationComponent from '../../../Component/Animation';
import StateComponent from '../../../Component/State';
import { IGameState } from '../../../State/Game/IGameState';
import { GameScene } from '../../../State/Game/GameScene';
import Renderable from '../../../Component/Renderable';
import GameObject, { GameObjectEvent } from '../../../GameObject/GameObject';
import ButtonComponent from '../../../Component/UI/ButtonComponent';
import UIImageComponent from '../../../Component/UI/Image';
import {
    Anim,
    StartAnimation,
    StopAnimation,
} from '../../../System/Animation/AnimationHelper';
import Point from '../../../Utility/Point';
import { CrossPromoStatus } from '../../../State/Game/IUserState';
import CrossPromoDriver, {
    CrossPromoPlacement,
    CrossPromoAssetType,
} from '../../../Utility/CrossPromo/CrossPromoDriver';
import CrossPromoCampaign from '../../../Utility/CrossPromo/CrossPromoCampaign';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import { CROSS_PROMO_FROM_LEVEL_NUMBER } from '../../../Constants/CrossPromo';


export default class CrossPromoMenuButton extends Element {
    public static BUTTON_NAME: string = 'cross_promo_HUD_button';

    private button: Element;
    private campaign: any;
    private xPromoClicked: boolean;

    public create(params: any): void {
        super.create({
            name: params.name,
            layout: {
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
                ...params.layout,
            },
            children: [
                {
                    name: CrossPromoMenuButton.BUTTON_NAME,
                    layout: {
                        anchors: [0.5, 0.5, 0.5, 0.5],
                        pivot: [0.5, 0.5],
                        offsets: [0, 1, 0, 1],
                        constrains: {
                            heightMax: 110,
                            heightMin: 110,
                            widthMax: 110,
                            widthMin: 110,
                        },
                    },
                    components: [
                        {
                            type: 'input',
                            data: {
                                enabled: true,
                                buttonMode: true,
                                toggleable: true,
                                tintOnDisable: true,
                            },
                        },
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'popup_goal_fail',
                            },
                        },
                    ],
                },
            ],
            ...params,
        });
        this.addComponent(AnimationComponent);
        this.addComponent(StateComponent, {
            handleStateChanged: this.handleStateChanged.bind(this),
        });

        const state: IGameState = Game.store.getState();
        const playerState = state.playerState;
        this.xPromoClicked = playerState.progress.xPromoWasShown;

        const renderable: Renderable = this.getComponent<Renderable>(
            Renderable
        );

        renderable.visible = false;

        this.button = GameObject.findFirstByName(
            CrossPromoMenuButton.BUTTON_NAME
        ) as Element;

        this.button.addComponent(ButtonComponent, {
            toggleable: true,
        });
        this.button.on(GameObjectEvent.SELECTED, this.onSelect.bind(this));

        this.handleStateChanged(state);
    }

    private onSelect(): void {
        if (this.campaign === undefined) return;
        this.xPromoClicked = true;
        StopAnimation(this);
        this.container.rotation = 0;
        PlayerActions.openCrossPromoMenu(this.campaign);

        Anim(this, {
            alpha: 0,
            duration: 450,
        }).then(() => {
            this.getComponent(Renderable).visible = false;
        })
    }

    public handleStateChanged(state: IGameState): void {
        if (this.campaign === undefined) {
            const renderable: Renderable = this.getComponent<Renderable>(
                Renderable
            );
            renderable.visible = false;
            CrossPromoDriver.getCampaignOfType(
                CrossPromoPlacement.ICON_PICTURE_COMBO,
                state
            ).then(this.onCampaignFound);
        }
        this.xPromoClicked = state.perSessionData.hasClickedXPromoHUDButton;
    }

    private readonly onCampaignFound = (campaign: CrossPromoCampaign): void => {
        if (this.destroyed) return;
        const renderable: Renderable = this.getComponent<Renderable>(
            Renderable
        );

        if (campaign === undefined) {
            renderable.visible = false;
            return;
        }

        this.campaign = campaign;
        campaign
            .loadAsset(CrossPromoAssetType.ICON, Game.sdk.getLanguage())
            .catch((error: any) =>
                console.warn('Failed to get XPromo Asset', error)
            )
            .then(this.onAssetLoaded.bind(this));
    };

    public onAssetLoaded(key: string): void {
        if (this.destroyed) return;
        const renderable: Renderable = this.getComponent<Renderable>(
            Renderable
        );

        this.button.getComponent(UIImageComponent).texture = key;
        renderable.visible = CrossPromoMenuButton.canShow();
    }

    public idle(): void {
        if (!this.xPromoClicked && !this.destroyed) {
            StartAnimation(this, 'Wiggle', {
                duration: 150,
                scale1: new Point(0.92, 0.92),
                scale2: new Point(1.08, 1.08),
                delay: 5000,
                loop: true,
                rotationAngle: 10,
            });
        }
    }

    public static canShow(state: IGameState = Game.store.getState()): boolean {
        const isWorld: boolean = state.activeScene.result === GameScene.WORLD;
        const enabled: boolean =
            state.userState.crossPromo === CrossPromoStatus.ENABLED;
        const ftuePassed =
            Game.player.getHighestLevelCompleted(state) >= CROSS_PROMO_FROM_LEVEL_NUMBER;
        const clickedOnce = state.perSessionData.hasClickedXPromoHUDButton;

        return isWorld && enabled && ftuePassed && !clickedOnce;
    }
}
